import React from 'react';
import { LUGARES_QUIROFANO, useListaClinica } from '../../lib/listasClinica';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

/**
 * Desplegable del lugar del quirófano de un día (V2, 28/9/2026).
 *
 * Los lugares son una lista de la clínica («Lugares del quirófano», en el
 * Catálogo de cirugías; ver `backend/services/listas_clinica.py`). Antes
 * venían escritos en cada diálogo. El servidor comprueba lo elegido contra
 * esa misma lista.
 *
 * El lugar que ya tenía el día se sigue ofreciendo aunque hoy no esté en la
 * lista, para no perderlo al abrir el diálogo. Con la lista vacía se dice
 * dónde se rellena: sin lugares no se puede fijar el quirófano de un día.
 *
 * Props: { value, onChange, dataTestid, placeholder }
 */
export default function LugarQuirofanoSelect({ value, onChange, dataTestid, placeholder }) {
  const [lugares, cargada] = useListaClinica(LUGARES_QUIROFANO);
  const nombres = lugares.map((l) => l?.nombre).filter(Boolean);
  const opciones = value && !nombres.includes(value) ? [...nombres, value] : nombres;
  return (
    <>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="mt-1.5" data-testid={dataTestid}>
          <SelectValue placeholder={placeholder || '¿Dónde es el quirófano?'} />
        </SelectTrigger>
        <SelectContent>
          {opciones.map((nombre) => (
            <SelectItem key={nombre} value={nombre}>{nombre}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {cargada && nombres.length === 0 && (
        <p className="text-[11px] text-amber-700 mt-1" data-testid={`${dataTestid}-vacio`}>
          La clínica no tiene lugares de quirófano: se añaden en Catálogo de cirugías → Lugares
          del quirófano.
        </p>
      )}
    </>
  );
}
